<template>
  <div>
    <page-header>
      <template #breadcrumbs> Регистр ЛРАС </template>
      <h2>Регистр ЛРАС</h2>
      <template #actions>
        <div class="d-flex align-items-baseline actions">
          <div class="mx-2">
            <div class="search-filed">
              <component-input
                :maxNumberLength="6"
                @keyupEnter="onFiltersApply()"
                v-model="filters.searchRegNumber"
                placeholder="Введите рег.номер для поиска..."
              />
              <div
                @click="
                  filters.searchRegNumber = '';
                  onFiltersApply();
                "
                v-if="filters.searchRegNumber && filters.searchRegNumber.length"
                class="cross"
              >
                <icon-component name="cross" />
              </div>
              <button
                type="button"
                class="btn btn-default"
                v-on:click="onFiltersApply()"
              >
                <icon-component name="searchSvg" />
              </button>
            </div>
          </div>
          <div class="search-wrapper mx-2">
            <div class="search-tooltip"><sup><i class="fa fa-info-circle text-gray" :title="searchTooltip"></i></sup></div>
            <div class="search-filed">
              <component-input
                @keyupEnter="filters.searchRegNumber = '';onFiltersApply()"
                v-model="filters.searchText"
                placeholder="Введите данные для поиска..."
              />
              <div
                @click="
                  filters.searchText = '';
                  onFiltersApply();
                "
                v-if="filters.searchText && filters.searchText.length"
                class="cross"
              >
                <icon-component name="cross" />
              </div>
              <button
                type="button"
                class="btn btn-default"
                v-on:click="filters.searchRegNumber = '';onFiltersApply()"
              >
                <icon-component name="searchSvg" />
              </button>
            </div>
            <div
              v-if="keyboardSuggestion"
              class="search-suggestion"
            >
              Возможно, вы имели в виду:
              <span
                class="search-suggestion-link"
                @click="applySuggestion"
              >
                {{ keyboardSuggestion }}
              </span>
            </div>
          </div>

          <button-component v-if="canEdit" class="mx-2" @click="importRmis()">
            Загрузить из ЕЦП
          </button-component>
          <button-component
            class="mx-2"
            v-if="canImportExcel"
            :disabled="importInProgress"
            @click="importExcel()"
          >
            <template v-if="!importInProgress">Загрузить из Excel</template>
            <template v-else>Загрузка...</template>
          </button-component>
          <button-component class="button-component_success mx-2" @click="exportExcel()" title="Экспорт в эксель">
            <template v-if="!exportInProgress"><i class="fa fa-download" style="color:#fff"></i></template>
            <template v-else><i class="fa fa-spinner fa-spin" style="color:#fff"></i></template>
          </button-component>
          <button-component v-if="canEdit" @click="editCard(0)"
            >Создать</button-component
          >
          <button-component
            class="mx-2"
            kind="tertiary"
            :class="{ filtered: isFiltered }"
            @click="modals.filter = !modals.filter"
          >
            <template #prepend>
              <icon-component class="mr-2" name="filter" />
            </template>
            Фильтр
          </button-component>
        </div>
      </template>
    </page-header>

    <section class="content">
      <template v-if="page.items?.length">
        <div class="table-inner">
          <table class="table-custom">
            <thead>
              <tr>
                <th></th>
                <th class="col-table-1">ФИО</th>
                <th>Пол</th>
                <th class="col-table-1">СНИЛС</th>
                <th>Возраст</th>
                <th class="col-table-4">Дата рождения</th>
                <th class="col-table-6 td-center">Статус взаимодействия</th>
                <th>Район</th>
                <th class="col-table-2">Дата внесения в Регистр</th>
                <th class="col-table-6 td-center">Дневник</th>
                <th class="col-table-2 td-center">Диагностика</th>
                <th v-if="generalQuestionsChat">Мессенджер</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in page.items"
                :key="item.id"
                :class="{ deleted: item.isDeleted, deletedPerm: item.isDeletedPermanently }"
                v-on:dblclick="editCard(item.id, item.isDeleted || item.isDeletedPermanently)"
              >
                <td>
                  <menu-component class="actions" :actions="actions(item)" />
                </td>
                <td>
                  {{ item.surname }} {{ item.name }} {{ item.patronimic }}
                  <template v-if="item.comment">
                    <sup class="pr-1"><i class="fa fa-info-circle color-blue" :title="item.comment"></i></sup>
                  </template>
                  <template v-if="item.info">
                    <sup><i class="fa fa-info-circle color-red" :title="item.info"></i></sup>
                  </template>
                </td>
                <td>{{ item.male ? "М" : "Ж" }}</td>
                <td>{{ item.snils }}</td>
                <td>{{ item.age }}</td>
                <td>{{ $momentFormat(item.dateOfBirth, "DD.MM.YYYY") }}</td>
                <td class="td-center">
                  <span
                    class="icon-status"
                    :title="
                      item.statusName +
                      (item.statusComment ? ': ' + item.statusComment : '')
                    "
                    ><i class="fas fa-check" :class="item.statusColor"></i
                  ></span>
                </td>
                <td>{{ getDistrictName(item.district) }}</td>
                <td>{{ $momentFormat(item.created, "DD.MM.YYYY") }}</td>
                <td class="td-center">
                  <button
                    v-if="item.journalId"
                    class="btn"
                    @click="goToJournal(item.id)"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 17 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.0586 0.633301C15.4753 0.633301 15.8294 0.779134 16.1211 1.0708C16.4128 1.36247 16.5586 1.71663 16.5586 2.1333V13.1333C16.5586 13.55 16.4128 13.9041 16.1211 14.1958C15.8294 14.4875 15.4753 14.6333 15.0586 14.6333H2.05859C1.64193 14.6333 1.28776 14.4875 0.996094 14.1958C0.704427 13.9041 0.558594 13.55 0.558594 13.1333V2.1333C0.558594 1.71663 0.704427 1.36247 0.996094 1.0708C1.28776 0.779134 1.64193 0.633301 2.05859 0.633301H15.0586ZM14.8711 13.1333C14.9961 13.1333 15.0586 13.0708 15.0586 12.9458V2.3208C15.0586 2.1958 14.9961 2.1333 14.8711 2.1333H2.24609C2.12109 2.1333 2.05859 2.1958 2.05859 2.3208V12.9458C2.05859 13.0708 2.12109 13.1333 2.24609 13.1333H14.8711ZM13.5586 10.2583V11.0083C13.5586 11.2583 13.4336 11.3833 13.1836 11.3833H6.93359C6.68359 11.3833 6.55859 11.2583 6.55859 11.0083V10.2583C6.55859 10.0083 6.68359 9.8833 6.93359 9.8833H13.1836C13.4336 9.8833 13.5586 10.0083 13.5586 10.2583ZM13.5586 7.2583V8.0083C13.5586 8.2583 13.4336 8.3833 13.1836 8.3833H6.93359C6.68359 8.3833 6.55859 8.2583 6.55859 8.0083V7.2583C6.55859 7.0083 6.68359 6.8833 6.93359 6.8833H13.1836C13.4336 6.8833 13.5586 7.0083 13.5586 7.2583ZM13.5586 4.2583V5.0083C13.5586 5.2583 13.4336 5.3833 13.1836 5.3833H6.93359C6.68359 5.3833 6.55859 5.2583 6.55859 5.0083V4.2583C6.55859 4.0083 6.68359 3.8833 6.93359 3.8833H13.1836C13.4336 3.8833 13.5586 4.0083 13.5586 4.2583ZM5.33984 3.85205C5.56901 4.06038 5.68359 4.3208 5.68359 4.6333C5.68359 4.9458 5.56901 5.21663 5.33984 5.4458C5.13151 5.65413 4.87109 5.7583 4.55859 5.7583C4.24609 5.7583 3.97526 5.65413 3.74609 5.4458C3.53776 5.21663 3.43359 4.9458 3.43359 4.6333C3.43359 4.3208 3.53776 4.06038 3.74609 3.85205C3.97526 3.62288 4.24609 3.5083 4.55859 3.5083C4.87109 3.5083 5.13151 3.62288 5.33984 3.85205ZM5.33984 6.85205C5.56901 7.06038 5.68359 7.3208 5.68359 7.6333C5.68359 7.9458 5.56901 8.21663 5.33984 8.4458C5.13151 8.65413 4.87109 8.7583 4.55859 8.7583C4.24609 8.7583 3.97526 8.65413 3.74609 8.4458C3.53776 8.21663 3.43359 7.9458 3.43359 7.6333C3.43359 7.3208 3.53776 7.06038 3.74609 6.85205C3.97526 6.62288 4.24609 6.5083 4.55859 6.5083C4.87109 6.5083 5.13151 6.62288 5.33984 6.85205ZM5.33984 9.85205C5.56901 10.0604 5.68359 10.3208 5.68359 10.6333C5.68359 10.9458 5.56901 11.2166 5.33984 11.4458C5.13151 11.6541 4.87109 11.7583 4.55859 11.7583C4.24609 11.7583 3.97526 11.6541 3.74609 11.4458C3.53776 11.2166 3.43359 10.9458 3.43359 10.6333C3.43359 10.3208 3.53776 10.0604 3.74609 9.85205C3.97526 9.62288 4.24609 9.5083 4.55859 9.5083C4.87109 9.5083 5.13151 9.62288 5.33984 9.85205Z"
                        fill="#ABABB3"
                      />
                    </svg>
                  </button>
                </td>
                <td class="td-center">
                  <!-- Направить на диагностику	 -->
                  <button
                    :data-status="item.diagnosticStatusText"
                    class="btn"
                    v-if="item.journalId"
                    @click="
                      goToDiagnostic(
                        item.journalId,
                        item.diagnosticStatus,
                        item.diagnosticDateEnter,
                        item.diagnosticOganizationId
                      )
                    "
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.5273 4.1333C14.9023 4.1333 15.2461 4.22705 15.5586 4.41455C15.8711 4.58122 16.1107 4.8208 16.2773 5.1333C16.4648 5.42497 16.5586 5.7583 16.5586 6.1333C16.5586 6.90413 16.2253 7.47705 15.5586 7.85205V11.3833C15.5586 12.8208 15.0169 14.05 13.9336 15.0708C12.8711 16.1125 11.5794 16.6333 10.0586 16.6333C8.57943 16.6333 7.29818 16.1333 6.21484 15.1333C5.15234 14.1541 4.60026 12.9562 4.55859 11.5396C3.41276 11.3104 2.45443 10.7375 1.68359 9.8208C0.933594 8.8833 0.558594 7.8208 0.558594 6.6333V1.78955C0.558594 1.60205 0.610677 1.4458 0.714844 1.3208C0.839844 1.17497 0.985677 1.08122 1.15234 1.03955L3.12109 0.664551C3.32943 0.622884 3.51693 0.664551 3.68359 0.789551C3.85026 0.893717 3.95443 1.03955 3.99609 1.22705L4.08984 1.72705C4.13151 1.93538 4.08984 2.12288 3.96484 2.28955C3.86068 2.45622 3.71484 2.56038 3.52734 2.60205L2.55859 2.78955V6.6333C2.55859 7.46663 2.85026 8.17497 3.43359 8.7583C4.03776 9.34163 4.75651 9.6333 5.58984 9.6333C6.40234 9.6333 7.10026 9.33122 7.68359 8.72705C8.26693 8.12288 8.55859 7.41455 8.55859 6.60205V2.78955L7.58984 2.60205C7.38151 2.56038 7.21484 2.45622 7.08984 2.28955C6.98568 2.12288 6.95443 1.93538 6.99609 1.72705L7.12109 1.22705C7.14193 1.10205 7.19401 0.987467 7.27734 0.883301C7.36068 0.779134 7.46484 0.706217 7.58984 0.664551C7.71484 0.622884 7.85026 0.612467 7.99609 0.633301L9.96484 1.03955C10.1315 1.08122 10.2669 1.17497 10.3711 1.3208C10.4961 1.4458 10.5586 1.60205 10.5586 1.78955V6.6333C10.5586 7.8208 10.1732 8.87288 9.40234 9.78955C8.65234 10.7062 7.70443 11.2896 6.55859 11.5396C6.60026 12.1021 6.77734 12.6229 7.08984 13.1021C7.40234 13.5812 7.81901 13.9562 8.33984 14.2271C8.88151 14.4979 9.45443 14.6333 10.0586 14.6333C11.0169 14.6333 11.8398 14.3208 12.5273 13.6958C13.2148 13.05 13.5586 12.2791 13.5586 11.3833V7.85205C12.8711 7.47705 12.5378 6.89372 12.5586 6.10205C12.5794 5.56038 12.7773 5.10205 13.1523 4.72705C13.5273 4.33122 13.9857 4.1333 14.5273 4.1333ZM14.1836 6.5083C14.2878 6.59163 14.4128 6.6333 14.5586 6.6333C14.7044 6.6333 14.819 6.59163 14.9023 6.5083C15.0065 6.40413 15.0586 6.27913 15.0586 6.1333C15.0586 5.98747 15.0065 5.87288 14.9023 5.78955C14.819 5.68538 14.7044 5.6333 14.5586 5.6333C14.4128 5.6333 14.2878 5.68538 14.1836 5.78955C14.1003 5.87288 14.0586 5.98747 14.0586 6.1333C14.0586 6.27913 14.1003 6.40413 14.1836 6.5083Z"
                        fill="#ABABB3"
                      />
                    </svg>
                  </button>
                </td>
                <td v-if="generalQuestionsChat" class="td-center">
                  <div class="messenger" @click="openMessenger(item.id)">
                    <i class="far fa-comments"></i>
                    <span
                      :class="{ 'text-bold': item.unreadMessageCount > 0 }"
                      >{{ item.unreadMessageCount }}</span
                    >
                  </div>
                </td>
                <!--            <td class="table-action-cell">-->
                <!--              <button class="btn"><i class="fas fa-eye" v-on:click="viewCard(item.id)"/></button>-->
                <!--              <button class="btn"><i class="fas fa-pen" v-if="canEdit" v-on:click="editCard(item.id)"/></button>-->
                <!--              <button class="btn"><i class="fas fa-trash-alt" v-if="canEdit" v-on:click="deleteCard(item.id)"/></button>-->
                <!--            </td>-->
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="page.pagesTotal > 1">
          <Pagination
            :page-count="page.pagesTotal"
            :current-page="page.pageNumber"
            @change="onPageChange($event)"
          />
        </div>
        <div>
          <PageCounter
            :isFiltered="isFiltered"
            :totalCount="totalCount"
            :filteredCount="page.itemsTotal"
          />
        </div>
      </template>
      <template v-else>
        <EmptyListMessage />
      </template>
      <section class="modals">
        <transition name="filter">
          <div class="filter" v-if="modals.filter">
            <PatientsFilters
              v-bind:filters="filters"
              v-on:apply="onFiltersApply($event)"
              v-on:reset="onFiltersReset($event)"
            />
          </div>
        </transition>
        <modal-component
          v-if="modals.diagnostic.show"
          title="Направить на диагностику"
          size-class=""
          @close="modals.diagnostic.show = false"
        >
          <diagnostic-date-enter
            :journal-id="modals.diagnostic.journalId"
            :date-diagnostic="modals.diagnostic.dateDiagnostic"
            :org-id="modals.diagnostic.orgId"
            :is-approve="modals.diagnostic.isApprove"
            @close="modals.diagnostic.show = false"
            @save="loadPage()"
          />
        </modal-component>
        <modal-component
          class="modal-content--card"
          v-if="modals.importRmis.show"
          title="Импорт данных из ЕЦП"
          @close="modals.importRmis.show = false"
        >
          <import-patient @close="modals.importRmis.show = false" />
        </modal-component>
        <modal-component
          v-if="modals.deleteReason"
          title="Причина исключения из реестра"
          size-class=""
          @close="modals.deleteReason = false"
        >
          <delete-reason
            v-on:delete="deleteConfirmed"
            @close="modals.deleteReason = false"
          />
        </modal-component>
        <modal-component
          v-if="modals.deletePermanentlyReason"
          title="Причина удаления из реестра"
          size-class=""
          @close="modals.deletePermanentlyReason = false"
        >
          <delete-permanently-reason
            v-on:delete="deleteConfirmed"
            @close="modals.deletePermanentlyReason = false"
          />
        </modal-component>
        <modal-component
          v-if="modals.messenger.show"
          title="Мессенджер"
          class="modal-content--card"
          @close="modals.messenger.show = false"
        >
          <MessengerForm :filter="modals.messenger.filter"></MessengerForm>
        </modal-component>
        <modal-component
          v-if="modals.importPatients"
          title="Импорт карточек людей с диагнозом РАС"
          size-class=""
          @close="modals.importPatients = false"
        >
          <import-patients
            v-on:doimport="doImport"
            @close="modals.importPatients = false"
          />
        </modal-component>
        <modal-component
          v-if="modals.shortPatientCard"
          size-class="modal-xl"
          title=""
          @close="modals.shortPatientCard = false"
        >
          <patient-short-card
            :id="modals.shortPatientCardId"
            @close="modals.shortPatientCard = false"
          />
        </modal-component>
      </section>
    </section>
  </div>
</template>

<script>
import API from "../api/ras";
import PatientsFilters from "./PatientsFilter.vue";
import { mapState } from "vuex";
import Constants from "@/common/constants";
import ButtonComponent from "@/common/ui/ButtonComponent";
import PageHeader from "@/common/components/page/PageHeader";

import ModalComponent from "@/common/ui/ModalComponent";
import IconComponent from "@/common/ui/IconComponent";
import DiagnosticDateEnter from "@/modules/journal/views/DiagnosticDateEnter";
import ImportPatient from "../components/ImportPatient.vue";
import security from "../../../common/mixins/security";
import MenuComponent from "../../../common/ui/components/page/MenuComponent";
import filtermanager from "../../../common/mixins/filtermanager";
import DeleteReason from "../components/DeleteReason";
import DeletePermanentlyReason from "../components/DeletePermanentlyReason";
import MessengerForm from "../../messenger/components/MessengerForm";
import ImportPatients from "../components/ImportPatients";
import userManager from "../../auth/user-manager";
import ComponentInput from "@/common/components/ComponentInput";
import PatientShortCard from "@/modules/ras/components/PatientShortCard";
import PageCounter from "@/common/components/PageCounter";
import Utils from "@/common/utils";

export default {
  name: "Patients",
  components: {
    ComponentInput,
    MessengerForm,
    DeleteReason,
    DeletePermanentlyReason,
    MenuComponent,
    IconComponent,
    ModalComponent,
    PageHeader,
    ButtonComponent,
    PatientsFilters,
    DiagnosticDateEnter,
    ImportPatient,
    ImportPatients,
    PatientShortCard,
    PageCounter,
  },
  mixins: [security, filtermanager],
  created() {
    //загрузить по-умолчанию
    this.request.pageNumber = this.$route.query.page ? this.$route.query.page * 1 : 1;
    this.checkPermission(Constants.PatientEdit).then((response) => {
      this.canEdit = response.data;
    });
    this.checkPermission(Constants.GeneralQuestionsChat).then((response) => {
      this.generalQuestionsChat = response.data;
    });
    
    userManager.getUser().then((user) => {
      this.canImportExcel =
        user.profile.role.indexOf(Constants.AdminRoleId) > -1;
    });

    this.getTotalCount();

    this.checkPermission(Constants.PatientDeletePermanentlyView).then((response) => {
      this.canViewDeletedPermanently = response.data;
      this.loadPage();
    });

    

    const filter = this.loadFilter();
    this.hideFilters = filter ? filter : this.filters;
  },
  data: () => ({
    request: {
      pageNumber: 1,
      pageSize: Constants.pageSize,
    },
    filters: {
      FIO: "",
      dateOfBirthFrom: null,
      dateOfBirthTo: null,
      createdFrom: null,
      createdTo: null,
      docType: 0,
      docSerieNum: "",
      insType: 0,
      isWaitDiagnostic: false,
      isDeleted: false,
      isDeletedPermanently: false,
      createdByOrgId: 0,
      statusId: 0,
      age: null,
      districtId: 0,
      male: null,
      exitFromConcept: null,
      searchText: "",
      searchRegNumber: "",
    },
    hideFilters: {},
    page: {},
    modals: {
      filter: false,
      view: false,
      diagnostic: {
        show: false,
        journalId: null,
        dateDiagnostic: null,
        orgId: null,
        isApprove: false
      },
      importRmis: {
        show: false,
      },
      deleteReason: false,
      deletePermanentlyReason: false,
      messenger: {
        filter: {
          dialogType: null,
          patientId: null,
          journalImarOrganizationId: null,
        },
        show: false,
      },
      importPatients: false,
      shortPatientCard: false,
      shortPatientCardId: null,
    },
    patient: null,
    canEdit: true,
    canViewDeletedPermanently: false,
    isFiltered: false,
    isLastFiltered: false,
    currentItemId: null,
    generalQuestionsChat: false,
    canImportExcel: false,
    importInProgress: false,
    totalCount: 0,
    exportInProgress: false,
    searchTooltip: Constants.searchTooltip
  }),
  methods: {
    getTotalCount() {
      const self = this;
      API.search(
        Object.assign({ pageNumber: 1, pageSize: 1 }, this.filters)
      ).then(function (response) {
        self.totalCount = response.data.itemsTotal;
      });
    },
    actions(item) {
      let acts = [
        {
          title: "Просмотр",
          icon: "eye",
          click: () => this.viewCard(item.id),
        },
      ];
      if (!item.isDeleted && !item.isDeletedPermanently && this.canEdit) {
        acts.push({
          title: "Редактировать",
          icon: "pen",
          click: () => this.editCard(item.id, item.isDeleted || item.isDeletedPermanently),
        });
        acts.push({
          title: "Обновить",
          icon: "refresh",
          click: () => this.refreshCard(item.id),
        });
      }
      acts.push({
        title: "Карточка",
        icon: "table-document-icon",
        click: () => this.shortCard(item.id),
      });

      if (!item.isDeleted && !item.isDeletedPermanently && this.canEdit) {
        acts = acts.concat([
          {
            title: "Исключить",
            icon: "trash",
            click: () => this.deleteCard(item.id, false),
          },
        ]);
      } else if (item.isDeleted && !item.isDeletedPermanently && this.canEdit) {
        acts = acts.concat([
          {
            title: "Восстановить из исключенных",
            icon: "trash-restore",
            click: () => this.restoreCard(item.id),
          },
        ]);
      }
      if (this.canEdit && !item.isDeletedPermanently) {
        acts.push({
          title: "Удалить",
          icon: "delete",
          click: () => this.deleteCard(item.id, true),
        });
      } else if(this.canEdit && item.isDeletedPermanently) {
        acts = acts.concat([
          {
            title: "Восстановить из архива",
            icon: "trash-restore",
            click: () => this.restorePermanentlyCard(item.id),
          },
        ]);
      }
      return acts;
    },
    showCreateModal() {
      this.patient = 0;
      this.modals.view = true;
    },
    onPageChange(pageNumber) {
      this.request.pageNumber = pageNumber;
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pageNumber
        }
      });
      this.loadPage();
    },
    loadPage() {
      this.modals.diagnostic.show = false;
      const filter = this.loadFilter();
      if (filter) {
        this.filters = filter;
        this.isFiltered = true;
      }
      var params = Object.assign(this.filters, this.request);
      if(!this.canViewDeletedPermanently)//видит только архивные
        params.isDeletedPermanently = false;
      API.search(params).then((response) => {
        //console.log(response.data);
        this.page = response.data;
      });
    },
    onFiltersApply(filters) {
      const regNumber = this.filters.searchRegNumber?.trim();
      const searchText = this.filters.searchText?.trim();


      if (filters) {
        this.filters = filters;
        this.hideFilters = filters;
        this.isFiltered = true;
        this.isLastFiltered = true;
        this.filters.searchText = "";
        this.filters.searchRegNumber = "";
        this.saveFilter(this.filters);        
      } else if (!regNumber && !searchText) {
        this.filters = Object.assign({}, this.hideFilters);
        this.isFiltered = this.isLastFiltered;

        this.filters.searchText = "";
        this.filters.searchRegNumber = "";

        if (this.isFiltered) this.saveFilter(this.filters);

      } else {
        if (regNumber) {
          this.filters = {
            searchRegNumber: regNumber,
          };
        } else {
          this.filters = {
            searchText: searchText,
          };
        }

        this.isFiltered = false;
        this.removeFilter();
      }

      this.modals.filter = false;
      this.request.pageNumber = 1;
      this.loadPage();
    },
    onFiltersReset(filters) {
      this.filters = filters || {};
      this.hideFilters = filters || {};
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.removeFilter();
      this.isFiltered = false;
      this.isLastFiltered = false;
      this.loadPage();
    },
    viewCard(id) {
      this.$router.push({
        name: "patientCard",
        params: { id: id, action: "view" },
        query: { page: this.request.pageNumber }
      });
    },
    shortCard(id) {
      this.modals.shortPatientCardId = id;
      this.modals.shortPatientCard = true;
    },
    editCard(id, isItemDelete) {
      if (this.canEdit && !isItemDelete) {
        this.$router.push({
          name: "patientCard",
          params: { id: id, action: "edit" },
          query: { page: this.request.pageNumber }
        });
      } else {
        this.viewCard(id);
      }
    },
    deleteCard(id, permanently) {
      if (permanently) {
        this.currentItemId = id;
        this.modals.deletePermanentlyReason = true;
      } else {
        this.currentItemId = id;
        this.modals.deleteReason = true;
      }
    },
    deleteConfirmed(reason, isPermanently) {
      this.modals.deleteReason = false;
      this.modals.deletePermanentlyReason = false;
      var modalTitle = isPermanently ? "Удаление" : "Исключение";
      API.delete({ id: this.currentItemId, reason: reason, permanently: isPermanently })
        .then((response) => {
          Constants.alert.fire(
            modalTitle,
            response.data.message,
            response.data.success ? "success" : "error"
          );
          this.getTotalCount();
          this.loadPage();
        })
        .catch(() => {
          Constants.alert.fire(modalTitle, Constants.commonError, "error");
        });
    },
    restoreCard(id) {
      API.restore(id)
        .then((response) => {
          Constants.alert.fire(
            "Восстановление",
            response.data.message,
            response.data.success ? "success" : "error"
          );
          this.getTotalCount();
          this.loadPage();
        })
        .catch(() => {
          Constants.alert.fire(
            "Восстановление",
            Constants.commonError,
            "error"
          );
        });
    },
    restorePermanentlyCard(id) {
      API.restorePermanently(id)
        .then((response) => {
          Constants.alert.fire(
            "Восстановление",
            response.data.message,
            response.data.success ? "success" : "error"
          );
          this.getTotalCount();
          this.loadPage();
        })
        .catch(() => {
          Constants.alert.fire(
            "Восстановление",
            Constants.commonError,
            "error"
          );
        });
    },
    goToDiagnostic(journalId, status, dateDiagnostic, orgId) {
      this.modals.diagnostic = {
        show: true,
        journalId: journalId,
        dateDiagnostic: status == 2 ? null : dateDiagnostic,
        orgId: orgId,
        isApprove: status == 3
      };
    },
    goToJournal(id) {
      this.$router.push({
        name: "journalCard",
        params: { action: "view", id: id },
        query: { page: this.request.pageNumber }
      });
    },
    importRmis() {
      this.modals.importRmis = {
        show: true,
      };
    },
    openMessenger(id) {
      this.modals.messenger.filter = {
        dialogType: 2,
        patientId: id,
        journalImarOrganizationId: null,
      };
      this.modals.messenger.show = true;
    },
    importExcel() {
      this.modals.importPatients = true;
    },
    exportExcel() {
      if(this.exportInProgress)
        return;

      this.exportInProgress = true;
      const filter = this.loadFilter();
        if (filter) {
          this.filters = filter;
          this.isFiltered = true;
        }
        var params = Object.assign(this.filters, this.request);
        if(!this.canViewDeletedPermanently)//видит только архивные
          params.isDeletedPermanently = false;
        API.exportFile(params)
          .then((response) => {
            console.log("---- response");
            console.log(response);
            this.exportInProgress = false;
          })
          .catch((response) => {
            console.log(response);
            Constants.alert.fire("Экспорт", "Произошла ошибка", "error");
          })
          .finally(() => {
            this.exportInProgress = false;
          }); 
    },
    doImport(file) {
      this.modals.importPatients = false;
      this.importInProgress = true;
      API.importExcel(this.name, file)
        .then((response) => {
          if (response.data.success) {
            Constants.alert.fire("Импорт", response.data.message, "success");
          } else {
            Constants.alert.fire("Импорт", response.data.message, "error");
          }
          this.loadPage();
          this.importInProgress = false;
        })
        .catch((response) => {
          console.log(response);
          Constants.alert.fire(
            "Импорт",
            "Ошибка при импорте карточек людей.",
            "error"
          );
          this.importInProgress = false;
        });
    },
    getDistrictName(name) {
      if (name)
        return name
          .replace("г. Нижний Новгород,", "")
          .replace("городской округ", "")
          .replace("район", "")
          .trim();
      return "";
    },
    applySuggestion() {
      this.filters.searchText = this.keyboardSuggestion;
      this.filters.searchRegNumber = "";
      this.onFiltersApply();
    }
  },
  computed: {
    ...mapState({
      page: (state) => state.admin.roles.listPage,
    }),
    keyboardSuggestion() {
      const text = this.filters.searchText?.trim();
      if (!text) {
        return null;
      }

      // есть ли латинские буквы
      if (!/[a-z]/i.test(text)) {
        return null;
      }

      const converted = Utils.enToRu(text);

      return converted !== text
        ? converted
        : null;
    }
  },
  watch: {
    '$route.query.page': {
      handler(newVal) {
        this.request.pageNumber = newVal ? newVal * 1 : 1;
        this.loadPage();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.content {
  padding: 16px 16px 0 16px;
  position: relative;
  height: auto;
  .filter {
    position: absolute;
    width: 350px;
    height: auto;
    top: 0;
    right: 0;
    overflow: hidden;
    background-color: transparent;
    opacity: 1;
    transition: opacity 0.2s;
  }
  .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .table-inner {
    overflow: auto;
  }
}
.table-custom {
  td {
    min-height: 76px !important;
    height: 76px;
  }
}
.col-table {
  &-1 {
    min-width: 200px;
    max-width: 200px;
  }
  &-2 {
    min-width: 145px;
    max-width: 145px;
  }
  &-3 {
    min-width: 175px;
    max-width: 175px;
  }
  &-4,
  &-5 {
    min-width: 132px;
    max-width: 132px;
  }
  &-6 {
    min-width: 139px;
    max-width: 139px;
  }
  &-7,
  &-8 {
    min-width: 142px;
    max-width: 142px;
  }
  &-9 {
    min-width: 65px;
    max-width: 65px;
  }
  &-10 {
    min-width: 72px;
    max-width: 72px;
  }
  &-11 {
    min-width: 110px;
    max-width: 110px;
  }
  &-12 {
    min-width: 125px;
    max-width: 125px;
  }
}
.td-center {
  text-align: center;
}
.fa-eye,
.fa-pen,
.fa-trash-alt {
  color: $gray-medium;
}
.filtered {
  color: $red;
  &:hover {
    color: $red-dark;
  }
}
tr.deleted td {
  color: $gray-dark;
}
tr.deletedPerm td {
  color: $gray-dark;
  font-style: italic;
}
.icon-status {
  font-size: 24px;
}
.icon-status .green {
  color: $green;
  opacity: 0.6;
}
.icon-status .yellow {
  color: orange;
}
.icon-status .red {
  color: $red-dark;
}
.messenger {
  cursor: pointer;
  color: $blue-light;
  span {
    margin-left: 8px;
  }
}
.search-filed {
  position: relative;
  width: 320px !important;
  input {
    height: 100%;
  }

  .cross {
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 60px;
    .icon {
      width: 10px;
      height: 10px;
    }
  }
  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    background-color: #438ef0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    .icon {
      width: 20px;
      height: 23px;
    }
  }
}
.color-blue {
  color: $blue-light;
}
.color-red {
  color: $red;
}
.search-wrapper {
  display: inline-block;
  position: relative;
}
.search-tooltip {
  position: absolute;
  left: 3px;
  top: 1px;
  z-index: 1;
  // opacity: 0.5;

  // &:hover {
  //   opacity: 1;
  // }
}
</style>
